<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar o ajuste de estoque de código <b>{{this.entry.code}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(stockAdjustment) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_STOCK_ADJUSTMENT_MUTATION,
          variables: {
            id: stockAdjustment.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyStockAdjustment.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_STOCK_ADJUSTMENT_MUTATION = gql `
  mutation($id: ID!) {
    destroyStockAdjustment(id: $id) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>